<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="退换货信息">
        <table cellspacing="0" cellpadding="0" class="ProjectOrderTable" style="width: 100%;">
          <tr>
            <td class="tableLabel">系统编号：</td>
            <td>{{replacementBillVo.billNo}}</td>
            <td class="tableLabel">登记日期：</td>
            <td>{{replacementBillVo.createTime}}</td>
            <td class="tableLabel">登记人：</td>
            <td>{{replacementBillVo.creatorName}}</td>
          </tr>
          <tr>
            <td class="tableLabel">前续订单：</td>
            <td>{{replacementBillVo.sourceOrder}}</td>
            <td class="tableLabel">客户名称：</td>
            <td>{{replacementBillVo.customerName}}</td>
            <td class="tableLabel">退货类型：</td>
            <td>
              <el-select v-model="replacementBillVo.type" disabled>
                <el-option label="退货" :value="0"/>
                <el-option label="换货" :value="1"/>
                <el-option label="寄售退回" :value="2"/>
                <el-option label="借出退回" :value="3"/>
              </el-select>
            </td>
          </tr>
          <tr>
            <td class="tableLabel">退货原因：</td>
            <td>{{replacementBillVo.orderReturnReasonName}}</td>
            <td class="tableLabel">退货事由：</td>
            <td>{{replacementBillVo.returnReasonName}}</td>
            <td class="tableLabel">是否安装：</td>
            <td>{{!replacementBillVo.installed ? '是' : '否'}}</td>
          </tr>
          <tr>
            <td class="tableLabel">发出时间：</td>
            <td>{{replacementBillVo.sendDate}}</td>
            <td class="tableLabel">返回快递单号：</td>
            <td>{{replacementBillVo.deliverSn}}</td>
            <td class="tableLabel">事由：</td>
            <td>{{replacementBillVo.reason}}</td>
          </tr>
          <tr>
            <td class="tableLabel">已使用时间（月）：</td>
            <td>{{replacementBillVo.usedDate}}</td>
            <td class="tableLabel">费用承担：</td>
            <td>{{replacementBillVo.bearCost}}</td>
            <td class="tableLabel">原因分析：</td>
            <td>{{replacementBillVo.reasonAnalise}}</td>
          </tr>
          <tr>
            <td class="tableLabel">处理意见：</td>
            <td>{{replacementBillVo.handleSuggestion}}</td>
            <td class="tableLabel">是否开票：</td>
            <td>{{!replacementBillVo.ticketed ? '是' : '否'}}</td>
            <td class="tableLabel">一次性退货是否达到一万元：</td>
            <td>{{!replacementBillVo.overAmount ? '是' : '否'}}</td>
          </tr>
          <tr>
            <td class="tableLabel">到货信息是否一致：</td>
            <td>{{!replacementBillVo.consistent ? '是' : '否'}}</td>
            <td class="tableLabel">返厂流程单号：</td>
            <td>{{replacementBillVo.returnFactorySn}}</td>
            <td class="tableLabel">异常信息：</td>
            <td>{{replacementBillVo.exceptReason}}</td>
          </tr>
          <tr>
            <td class="tableLabel">订购原因：</td>
            <td>{{replacementBillVo.returnReasonName}}</td>
            <td class="tableLabel">质量分析结果：</td>
            <td colspan="3">{{replacementBillVo.qualityAnalise}}</td>
          </tr>
        </table>
      </el-tab-pane>
    </el-tabs>
    <!-- 产品信息-发出 -->
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">产品信息-发出</div>
      <el-table
          :data="replacementBillVo.details"
          border>
        <el-table-column prop="materialNo" width="160" align="center" label="物料号"/>
        <el-table-column prop="productModel" width="160" align="center" label="产品型号"/>
        <el-table-column prop="productName" width="160" align="center" label="产品名称"/>
        <el-table-column prop="quality" width="120" align="center" label="数量"/>
        <el-table-column prop="unit" width="120" align="center" label="单位"/>
        <el-table-column prop="amount" width="120" align="center" label="单价"/>
        <el-table-column prop="totalAmount" width="120" align="center" label="金额（合计）"/>
        <el-table-column prop="memo" align="center" label="备注"/>
        <el-table-column prop="delivered" width="120" align="center" label="是否已发货">
          <template slot-scope="scope">
            {{!scope.row.delivered ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="deliverSn" align="center" label="发运单号"/>
        <el-table-column prop="deliverDate" width="220" align="center" label="出库时间"/>
      </el-table>
    </div>
    <!-- 产品信息-退回 -->
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">产品信息- 退回</div>
      <el-table
          :data="replacementBillVo.returnMaterialDetails"
          border>
        <el-table-column prop="materialNo" width="160" align="center" label="物料号"/>
        <el-table-column prop="productModel" width="160" align="center" label="产品型号"/>
        <el-table-column prop="productName" width="160" align="center" label="产品名称"/>
        <el-table-column prop="sn" width="175" align="center" label="序列号"/>
        <el-table-column prop="quality" width="120" align="center" label="数量"/>
        <el-table-column prop="unit" width="120" align="center" label="单位"/>
        <el-table-column prop="amount" width="120" align="center" label="单价"/>
        <el-table-column prop="totalAmount" width="120" align="center" label="金额（合计）"/>
        <el-table-column prop="memo" align="center" label="备注"/>
        <el-table-column prop="delivered" width="120" align="center" label="是否已发货">
          <template slot-scope="scope">
            {{!scope.row.delivered ? '是' : '否'}}
          </template>
        </el-table-column>
        <el-table-column prop="deliverSn" align="center" label="发运单号"/>
        <el-table-column prop="deliverDate" width="220" align="center" label="出库时间"/>
      </el-table>
    </div>
    <!-- 订单附件 -->
    <div>
      <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">订单附件</div>
      <el-table
          ref="payData1"
          :data="replacementBillVo.attachments">
        <el-table-column type="index" align="center" label="行号"/>
        <el-table-column prop="fileName" align="center" label="图片">
          <template slot-scope="scope">
            <el-image
                style="width: 50px; height: 50px;margin-right: 10px"
                :src="scope.row.imgUrl"
                :preview-src-list="imgUrls"/>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" align="center" label="附件描述"/>
        <el-table-column label="操作" align="center" width="140" class-name="vm-table_operate">
          <template slot-scope="scope">
            <el-button type="primary" @click="downLoad(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    name:"AppointmentPreview",
    data() {
      return {
        billId:"",
        saveLoading: false,
        imgUrls: [],
        replacementBillVo: {
          pkid: "",
          billNo: "",
          createTime: "",
          creatorName: "",
          sourceOrder: "",
          customerName: "",
          typeName: "",
          orderReturnReasonName: "",
          returnReasonName: "",
          installed: "",
          sendDate: "",
          deliverSn: "",
          reason: "",
          usedDate: "",
          bearCost: "",
          reasonAnalise: "",
          handleSuggestion: "",
          ticketed: "",
          overAmount: "",
          consistent: "",
          returnFactorySn: "",
          exceptReason: "",
          orderReason: "",
          qualityAnalise: "",
          returnMaterialDetails: [],
          details: [],
          attachments: [],
        },
      };
    },
    created() {
      this.billId = this.$route.query.billId;
      this.getData();
    },
    destroyed() {
      this.billId = "";
      this.replacementBillVo={};
    },
    methods:{
      getData() {
        this.$http.get("basic",`replacementBills/${this.billId}`).then((res)=>{
          this.replacementBillVo = res.data;
          this.replacementBillVo.attachments.forEach(row => {
            this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
              if (res.success) {
                row.imgUrl = res.data;
                this.imgUrls.push(row.imgUrl);
              }
            });

          });
        }).catch(()=>{
        });
      },
      downLoad(row) {
        console.log(row);
        let url = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
        let a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.download = row.filePath;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      },
    },
  };
</script>

<style lang="scss">
table.ProjectOrderTable {
  font-family: verdana,arial,sans-serif;
  font-size:11px;
  color:#333333;
  border-left: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}
table.ProjectOrderTable th {
  text-align: left;
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ebeef5;
  background-color: #f4f7fa;
}
table.ProjectOrderTable td {
  padding: 8px;
  border-right: 1px solid #ebeef5;
  border-top: 1px solid #ebeef5;
}
.tableLabel {
  width: 10%;
  text-align: right;
  background-color: #D1E6F5;
}
</style>
